import '@babel/polyfill'; // IE 11 support
import 'url-polyfill'; // IE 11 support
import 'whatwg-fetch'; // IE 11 support
import Vue from 'vue';
import i18n from './i18n';
import bones from './bones/bones';
import router from './router';
import VueUtil from './utils/VueUtil';
import App from './App';

Vue.config.productionTip = false;

VueUtil.plugins = {
  router,
  bones,
  i18n,
};

new Vue({ ...VueUtil.plugins, render: h => h(App) }).$mount('#app');
